import React, { useState } from 'react'
import { FormControl, InputLabel, Select } from '@material-ui/core'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ShareIcon from '@material-ui/icons/Share'
import Typography from '@material-ui/core/Typography'

const StyledFormControl = styled(FormControl)`
  margin: 0;
  min-width: 120px;
`
const StyledInputLabel = styled(InputLabel)`
  color: ${({ theme }) => theme.colors.gray[700]};
  font-size: 1.5rem;
  cursor: pointer;
  &.Mui-focused {
    color: ${({ theme }) => theme.colors.gray[700]};
  }
`
export const WipReportPreviewButton = ({ onClick }) => {
  return (
    <StyledFormControl data-testid="wip.shareButton">
      <StyledInputLabel id="wip-select-label" onClick={onClick}>
        <div style={{ display: 'flex' }}>
          <ShareIcon htmlColor="#6750A4" fontSize="medium" />

          <Typography>
            <strong> Share WIP</strong>
          </Typography>
        </div>
      </StyledInputLabel>
    </StyledFormControl>
  )
}

WipReportPreviewButton.propTypes = {
  onClick: PropTypes.func,
}

export default WipReportPreviewButton
